import { Component, HostBinding, input, output } from '@angular/core';
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';
import { OutExpo } from '@exl-ng/mulo-common';
import { SharedModule } from '../../shared/shared.module';

const timing = 1000;

@Component({
    selector: 'exl-button-splash',
    templateUrl: './button-splash.component.html',
    styleUrls: ['./button-splash.component.scss'],
    host: { class: 'exl-button-splash' },
    animations: [
        trigger('splash', [
            state('start', style({ transform: 'scale(1)', opacity: 1 })),
            state('end', style({ transform: 'scale(2.5)', opacity: 0 })),
            state('reset', style({ transform: 'scale(0)', opacity: 0 })),
            transition('start => end', [animate(timing + 'ms ' + OutExpo)]),
            transition('* => reset', [animate(0)]),
        ]),
    ],
    imports: [SharedModule],
})
export class ButtonSplashComponent {
    readonly splashIcon = input(undefined);
    readonly rtlMirrorIcon = input<boolean>(undefined);
    readonly ariaLabel = input(undefined);
    readonly color = input<string>(undefined);
    readonly clicked = output();
    @HostBinding('class.is-animating') isAnimating = false;

    state: string;

    constructor() {
        this.state = 'reset';
    }

    onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.runAnimation();
        this.clicked.emit();
    }

    runAnimation() {
        this.state = 'start';
        this.isAnimating = true;
        setTimeout(() => {
            this.state = 'end';
        }, 0);
        // setTimeout(() => {
        //   this.stopAnimation()
        // }, timing);
    }

    stopAnimation() {
        this.state = 'reset';
        this.isAnimating = false;
    }
}
